<template>
  <v-page-content>
    <b-card class="universities-card" responsive>
      <b-row class="mb-3">
        <b-col sm="12" md="7">
          <h4>
            <em class="fas fa-university"></em> <span class="ml-2"> Вузы и СПО </span>
          </h4>
        </b-col>
      </b-row>
      <div class="ag-grid-vue-universities-list mt-2" ref="gridDiv">
        <ag-grid-vue
          class="universities ag-theme-material"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
          @rowSelected="onRowSelected"
          @filterChanged="onFilterChanged"
        >
        </ag-grid-vue>
      </div>
      <b-row class="sm pagination-row">
        <div class="ml-auto sm p-3 addButtons">
          <b-btn variant="primary"
                 class="addButton mr-1"
                 @click="onAddClicked"
          >
            <em class="fas fa-plus send-icon"></em> Добавить новый вуз / СПО
          </b-btn>

          <b-btn variant="primary"
                 class="addButton mr-1"
                 @click="removeUniversitiesFromResource"
                 v-b-modal.universitiesRemoveModal
                 :disabled="storageLength < 1"
          >
            <span v-if="storageLength < 1"
                  v-b-tooltip.mouseover
                  title="Выберите один или несколько вузов / СПО"
            >
              <em class="fas fa-times-circle"></em> Удалить
            </span>
            <span v-else>
              <em class="fas fa-times-circle"></em> Удалить
            </span>
          </b-btn>
        </div>
      </b-row>
    </b-card>
    <university-operations-modal
      :is-add-modal="isAddFunction"
      :chosen-university="selectedUniversity"
      @universityOperationCompleted="forceFetch"
    />
    <universities-remove-modal
      :chosen-universities="removableUniversities"
      @universitiesRemoved="forceFetch"/>
  </v-page-content>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

import _ from 'lodash'
import organizationApi from '@/api/organization'
import OrganizationActionsRenderer from '@/components/admin/actions/OrganizationActionsRenderer'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import { clientWidthType } from '@/config/config'
import PartialMatchFilter from '@/components/helpers/filters/PartialMatchFilter'

const UniversitiesRemoveModal = () => import('@/components/admin/modals/partners/UniversitiesRemoveModal.vue')
const UniversityOperationsModal = () => import('@/components/admin/modals/partners/UniversityOperationsModal.vue')

export default {
  name: 'Universities',
  components: {
    'ag-grid-vue': AgGridVue,
    UniversityOperationsModal,
    UniversitiesRemoveModal
  },
  data() {
    return {
      /* Все, что касается таблицы */
      gridOptions: {
        defaultColDef: {
          headerName: '',
          autoHeight: false,
          sortable: true,
          filter: 'PartialMatchFilter',
          headerClass: 'universities-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        suppressRowClickSelection: true,
        localeText: AG_GRID_LOCALE_RU,
        pagination: true,
        paginationPageSize: 20,
        rowHeight: 110,
        rowSelection: 'multiple',
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true,
        frameworkComponents: {
          OrganizationActionsRenderer,
          PartialMatchFilter
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: 'Название',
          field: 'title',
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          cellStyle: null,
          width: 350
        },
        {
          headerName: 'Город',
          field: 'city'
        },
        {
          headerName: 'Адрес',
          field: 'address',
          width: 300
        },
        {
          headerName: 'Сайт',
          field: 'siteUrl'
        },
        {
          headerName: ' ',
          field: 'edit',
          width: 54,
          cellRenderer: 'OrganizationActionsRenderer',
          filter: null
        }
      ],
      rowData: null,
      /* Остальное */
      storageLength: 0,
      selectedUniversities: [],
      selectedUniversity: null,
      removableUniversities: [],
      federalSubjects: [],
      isAddFunction: true
    }
  },
  created() {
    sessionStorage.clear()
    this.storageLength = 0
    organizationApi.getUniversities().then(({ data }) => {
      this.rowData = data
      this.gridOptions.api.setRowData(this.rowData)
    })
    this.debouncedFetchFilteredData = _.debounce((filters, sorting) => {
      this.debouncedFetch(filters, sorting)
    }, 500)
  },
  beforeDestroy() {
    sessionStorage.clear()
  },
  methods: {
    onFilterChanged() {
      this.debouncedFetchFilteredData(this.gridOptions.api.getFilterModel())
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.COMMON) {
        this.gridApi.sizeColumnsToFit()
      }
      params.api.resetRowHeights()
    },
    onGridSizeChanged() {
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.TIGHT) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    onRowSelected(params) {
      sessionStorage.setItem(params.node.data.id, params.node.selected)
      const keys = Object.keys(sessionStorage)
      this.storageLength = keys.filter((el) => (sessionStorage.getItem(el) === 'true')).length
    },
    onParentEditClicked(data) {
      this.isAddFunction = false
      this.selectedUniversity = data
      this.$bvModal.show('universityOperationsModal')
    },
    onAddClicked() {
      this.gridOptions.api.deselectAll()
      this.isAddFunction = true
      this.selectedUniversity = null
      this.$bvModal.show('universityOperationsModal')
    },
    async forceFetch() {
      sessionStorage.clear()
      this.storageLength = 0
      organizationApi.getUniversities().then(({ data }) => {
        this.rowData = data
        this.gridOptions.api.setRowData(this.rowData)
      })
    },
    debouncedFetch(filters) {
      organizationApi.getFilteredOrganizations({
        filters: filters || ' ',
        type: 'universities'
      })
        .then(({ data }) => {
          this.rowData = data
          this.gridOptions.api.setRowData(this.rowData)
        })
    },
    removeUniversitiesFromResource() {
      const keys = Object.keys(sessionStorage)
      this.selectedUniversities = keys.filter((el) => (sessionStorage.getItem(el) === 'true'))
      this.removableUniversities = this.rowData.filter(
        (cl) => this.selectedUniversities.includes(String(cl.id)),
      )
        .map((universityForRemove) => ({
          id: universityForRemove.id,
          title: universityForRemove.title,
          city: universityForRemove.city,
          address: universityForRemove.address,
          siteUrl: universityForRemove.siteUrl,
          year: universityForRemove.year
        }))
      this.$bvModal.show('universitiesRemoveModal')
    }
  }
}
</script>

<style lang="scss">
  @import "../../sass/vendor/bootstrap/variables";

  .universities {
    width: 100%;
    height: 100%;
  }

  .ag-grid-vue-universities-list {
    height: calc(100vh - 280px);
    border-bottom: 1px solid lightgray;
  }

  .universities-card .ag-grid-vue-universities-list .ag-cell {
    display: flex;
    align-items: center;
    font-size: 15px;
    justify-content: left;
    text-align: left;
    white-space: normal;
    line-height: 1.4em;
  }

  .universities-card .universities-table-header {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: left;
    color: #000;
    font-weight: bold;
  }

  .universities-card .ag-cell {
    padding-left: 24px !important;
  }

  .organizations-actions-renderer {
    cursor: pointer;
  }
</style>
